/*
* 展示年月日， 但返回的值 包含  年月日 时分秒 （）   例子： 系统右上角业务日期 头像旁边那个 （徐洋查询区让加的）
* 转过时区的
* */
import React, {Component} from 'react';
import DatePickerClientS from '../DatePickerTimeZoneConversion';
//import { getSysFieldid } from '@platform/api';
require('./index.less');


class DatePickerClient extends Component {
    constructor(props) {
        super(props);
        this.state = {current: '', localeLang: 'simpchn', json: {}};
    }

    render() {
        let {
            format = ['YYYY-MM-DD','YYYYMMDD','YYYY.MM.DD','YYYY/MM/DD'],
            className,
            ...others
        } = this.props;

        return (
            <DatePickerClientS
                {...others}
                needTime={true}
                needNowTime={true}
                format={format}
                MultiTZ={true}
                className={`DatePickerClient ${className}`}
            />
        );
    }
}

DatePickerClient.defaultProps = {
    showToday: false,
    showClear: true,
    renderIcon: () => {
        return <i className="icon iconfont">&#xe6cd;</i>;
    },
};
export default DatePickerClient;
